import * as yup from "yup";

export const reminderTypeSchema = yup.object().shape({
  name: yup.string().required().default("").label("Name"),
  day_or_month_count: yup.number().min(0).default("").label("Count"),
  is_month: yup.bool().label("Is month"),
  is_enabled_by_default: yup.bool().label("Is enabled by default"),
  // terms_and_conditions: yup.string().label("Terms and Condition"),
});
